export default function SectionLabel({ children, className = "" }) {
  return (
    <span
      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#10B981]/10 text-[#059669] text-[11px] font-semibold tracking-widest uppercase ${className}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-[#10B981]" />
      {children}
    </span>
  );
}
